//  Todo: Move up a level to share with QuickPayCashModal.
import * as React from 'react';
import styled from '@emotion/styled';
import { Input } from '@lightspeed/flame/Input';
import Format from 'app/src/data/Format';
import Localize from 'app/src/localize/Localize';
import Decimal from 'app/src/data/base/Decimal';

const inputMaxLength: number = 14; // 99 999 999 999.99 Should be enough
// We are doing this because forms.scss adds style to all input.
// By overriding it, we give the control back to flame.
const OverrideInput = styled(Input)`
  &&& {
    box-shadow: none;
  }
`;

export const PaymentInputField = ({
  value,
  isPaymentInputDisabled = false,
  onBlur,
  forwardedRef,
  ...props
}: TSFixMe) => {
  const [internalValue, setInternalValue] = React.useState(Format.formatMoney(0, 0, false));

  React.useEffect(() => {
    setInternalValue(Format.formatMoney(value, 0, false));
  }, [value]);

  const handleOnChange = (event: TSFixMe) => {
    const sanitizedInputValue = event.target.value.replace(/[^\d.]/, '');
    const allowInputPattern = new RegExp(/^\d{0,11}(.?\d{0,2})?$/);

    if (sanitizedInputValue.match(allowInputPattern) || sanitizedInputValue === '') {
      setInternalValue(sanitizedInputValue);
    }
  };
  if (isPaymentInputDisabled) {
    return <Input role="row" aria-label="no customer" disabled value="No Customer" />;
  }
  const handleOnBlur = () => {
    const maximumLengthWithDecimals = inputMaxLength - (Localize.getCurrencyPrecision() + 1);
    /** The following code will try to fit a decimal into the 'inputMaxLength' by transforming
     * the last digits into a decimal value based on the 'getCurrencyPrecision'
     * separated by a dot. */
    const trimmedAmount =
      internalValue.length > maximumLengthWithDecimals
        ? `${internalValue.substr(0, maximumLengthWithDecimals)}.${internalValue.substr(
            maximumLengthWithDecimals + 1,
            Localize.getCurrencyPrecision()
          )}`
        : internalValue;
    setInternalValue(Format.parseDecimal(trimmedAmount, new Decimal(0)));
    onBlur(trimmedAmount);
  };

  const handleOnFocusAmount = (event: TSFixMe) => {
    event.target.select();
  };

  const handleOnKeyPressAmount = (event: TSFixMe) => {
    // prevent the global keypress handler from firing
    event.stopPropagation();
    if (event.key === 'Enter') {
      // blurring the input will trigger the handleAmountBlur method
      event.currentTarget.blur();
    }
  };

  return (
    <OverrideInput
      autoComplete="off"
      value={internalValue}
      ref={forwardedRef}
      onFocus={handleOnFocusAmount}
      onKeyPress={handleOnKeyPressAmount}
      maxLength={inputMaxLength}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      {...props}
    />
  );
};
